/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAudits200ResponseMetaLinksInner
 */
export interface GetAudits200ResponseMetaLinksInner {
    /**
     * 
     * @type {string}
     * @memberof GetAudits200ResponseMetaLinksInner
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAudits200ResponseMetaLinksInner
     */
    label: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAudits200ResponseMetaLinksInner
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetAudits200ResponseMetaLinksInner interface.
 */
export function instanceOfGetAudits200ResponseMetaLinksInner(value: object): value is GetAudits200ResponseMetaLinksInner {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function GetAudits200ResponseMetaLinksInnerFromJSON(json: any): GetAudits200ResponseMetaLinksInner {
    return GetAudits200ResponseMetaLinksInnerFromJSONTyped(json, false);
}

export function GetAudits200ResponseMetaLinksInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAudits200ResponseMetaLinksInner {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'] == null ? undefined : json['url'],
        'label': json['label'],
        'active': json['active'],
    };
}

export function GetAudits200ResponseMetaLinksInnerToJSON(json: any): GetAudits200ResponseMetaLinksInner {
    return GetAudits200ResponseMetaLinksInnerToJSONTyped(json, false);
}

export function GetAudits200ResponseMetaLinksInnerToJSONTyped(value?: GetAudits200ResponseMetaLinksInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'label': value['label'],
        'active': value['active'],
    };
}

